import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Order, Response} from '../models/models';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalOrderService {

  constructor(private httpClient: HttpClient) {}

  insertOrder(order: Order): Observable<Response<Order>> {
    return this.httpClient.post<Response<Order>>(environment.apiPath + 'PortalOrder/', order);
  }

  validateClient(order: Order): Observable<Response<Order>> {
    return this.httpClient.post<Response<Order>>(environment.apiPath + 'PortalOrder/Validate/Client', order);
  }

  validateSender(order: Order): Observable<Response<Order>> {
    return this.httpClient.post<Response<Order>>(environment.apiPath + 'PortalOrder/Validate/Sender', order);
  }

  validateRecipient(order: Order): Observable<Response<Order>> {
    return this.httpClient.post<Response<Order>>(environment.apiPath + 'PortalOrder/Validate/Recipient', order);
  }

  validateVehicles(order: Order): Observable<Response<Order>> {
    return this.httpClient.post<Response<Order>>(environment.apiPath + 'PortalOrder/Validate/Vehicles', order);
  }
}
